import { Planner } from '@/common/types/databaseTypes';
import { create } from 'zustand';

export type DrawerView = 'detail' | 'timeBlock';

interface OpenDrawerProps {
    todoId: string | null;
    targetUserId: string;
    initialView?: DrawerView;
    plannerData?: Partial<Planner> | null;
    date?: Date | null;
}

interface TodoDrawerStore {
    selectedTodoId: string | null;
    isDrawerOpen: boolean;
    initialView: DrawerView;
    selectedDate: Date | null;
    selectedPlanner: Partial<Planner> | null;
    targetUserId: string; // 누구의 플래너를 보여줄지 결정 (target user id)
    isNotFoundModalOpen: boolean;

    openDrawer: (props: OpenDrawerProps) => void;
    closeDrawer: () => void;

    openNotFoundModal: () => void;
    closeNotFoundModal: () => void;
}

export const useTodoDrawerStore = create<TodoDrawerStore>(set => ({
    selectedTodoId: null,
    isDrawerOpen: false,
    initialView: 'detail',
    selectedDate: null,
    selectedPlanner: null,
    targetUserId: '',
    isNotFoundModalOpen: false,

    openDrawer: (props: OpenDrawerProps) => {
        return set({
            selectedTodoId: props.todoId,
            isDrawerOpen: true,
            initialView: props.initialView || 'detail',
            selectedDate: props.date,
            selectedPlanner: props.plannerData,
            targetUserId: props.targetUserId,
        });
    },
    closeDrawer: () => {
        return set({
            selectedTodoId: null,
            isDrawerOpen: false,
            initialView: 'detail',
            selectedDate: null,
            selectedPlanner: null,
            targetUserId: '',
        });
    },

    openNotFoundModal: () =>
        set({
            isDrawerOpen: false,
            isNotFoundModalOpen: true,
        }),
    closeNotFoundModal: () =>
        set({
            selectedTodoId: null,
            isNotFoundModalOpen: false,
        }),
}));
